import React, { useState, useEffect, useReducer } from 'react';
import '../../css/partnersPage.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { IoMdClose } from "react-icons/io";
import CustomFilterModal from '../../components/CustomFilterModal';
import CustomButton from '../../components/CustomButton';
import Form from 'react-bootstrap/Form';
import { IoSearch } from "react-icons/io5";
import { CiFilter } from "react-icons/ci";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { RiMapPinLine } from "react-icons/ri";
import Slider from '@mui/material/Slider';
import { styled, useTheme } from '@mui/material/styles';
import { filterReducer } from "../../features/checkBoxReducers/filterReducer";
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';
import ImgArrowRight from '../../assets/svg/arrowPartnersCards.svg';
import ImgNoMovementsDataSvg from '../../assets/svg/iconNoMovementsData.svg';
import useCodes from '../../hooks/useCodes';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setCategoryState } from '../../features/onboardingData/onboardingUserData';
import ListPagination from '../../components/ListPagination';
import { errorHandling } from '../../utils';
import portugalLocationsData  from "../../data/portugal.json";
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';
import { AiOutlineStop } from "react-icons/ai";
import { toast } from "react-toastify";
import GifIconLoading from '../../assets/gif/mainLoading.gif';

function PartnersPage() {

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingList, setIsLoadingList] = useState(false);
    const navigate = useNavigate();
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [isAccommodationTravel, setIsAccommodationTravel] = useState(false);
    const [isSustainability, setIsSustainability] = useState(false);
    const [isSport, setIsSport] = useState(false);
    const [isChildrenEducation, setIsChildrenEducation] = useState(false);
    const [isCultureLeisure, setIsCultureLeisure] = useState(false);
    const [isTech, setIsTech] = useState(false);
    const [isModaHome, setIsModaHome] = useState(false);
    const [isAnimals, setIsAnimals] = useState(false);
    const [isCarsTransp, setIsCarsTransp] = useState(false);
    const [isOther, setIsOther] = useState(false);
    const [isRestaurantStore, setIsRestaurantStore] = useState(false);
    const [isBeautyStore, setIsBeautyStore] = useState(false);
    const [isStoreOnline, setIsStoreOnline] = useState(false);
    const [isStorePhysical, setIsStorePhysical] = useState(false);
    const [openSelectFilteModal, setOpenSelectFilteModal] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [seacrhForNamePartner, setSeacrhForNamePartner] = useState('');
    const [seacrhForPlacePartner, setSeacrhForPlacePartner] = useState('');
    const MIN = 0;
    const MAX = 20;
    const [locationDistance, setLocationDistance] = useState(MIN);
    const [myLocation, setMyLocation] = useState('');
    const theme = useTheme();
    const location = useLocation();
    const category = location.state?.category || ''; 
    const seacrhCategory = location.state?.seacrhCategory || ''; 
    const [seacrhCategoryFiltr, setSeacrhCategoryFiltr] = useState('');
    const aroundMe = location.state?.aroundMe || MIN; 
    const [locationDistanceAroundMe, setLocationDistanceAroundMe] = useState(aroundMe);
    const [pageNumber, setPageNumber] = useState(1);
    const [numeroDePaginas, setNumeroDePaginas] = useState('');
    const { getIconType } = useCodes();
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isCategoryState = useSelector((state) => state.onboardingUserData.isCategoryState);
    const dispatchRedux = useDispatch();
    const [selectedSeacrhForNamePartner, setSelectedSeacrhForNamePartner] = useState(false);
    const [callGetParceirosSeacrhForNamePartner, setCallGetParceirosSeacrhForNamePartner] = useState(false);
    const [openDropDownSeacrhForNamePartner, setOpenDropDownSeacrhForNamePartner] = useState(false);
    const [isFocusedInputSeacrhForPlace, setIsFocusedInputSeacrhForPlace] =  useState(false);
    const [listaParceirosResp, setListaParceirosResp] = useState([]);
    const [countAccommodationTravel, setCountAccommodationTravel] = useState("");
    const [countSustainability, setCountSustainability] = useState("");
    const [countSport, setCountSport] = useState("");
    const [countBeautyStore, setCountBeautyStore] = useState("");
    const [countChildrenEducation, setCountChildrenEducation] = useState("");
    const [countCultureLeisure, setCountCultureLeisure] = useState("");
    const [countTech, setCountTech] = useState("");
    const [countModaHome, setCountModaHome] = useState("");
    const [countAnimals, setCountAnimals] = useState("");
    const [countCarsTransp, setCountCarsTransp] = useState("");
    const [countOther, setCountOther]= useState("");
    const [countRestaurantStore, setCountRestaurantStore] = useState("");
    const [countStoreOnline, setCountStoreOnline]= useState("");
    const [countStorePhysical, setCountStorePhysical] = useState("");
    const [countNew, setCountNew] = useState("");
    const [nomesParceirosList, setNomesParceirosList] = useState([]);
    const [numeroDeOcorrenciasParceiros, setNumeroDeOcorrenciasParceiros] = useState([]);
    const [isFocused, setIsFocused] =  useState(false);
    const [selectedSeacrhForPlacePartner, setSelectedSeacrhForPlacePartner] = useState(false);
    const [callGetParceirosSeacrhForPlacePartner, setCallGetParceirosSeacrhForPlacePartner] = useState(false);
    const [openDropDownSeacrhForPlacePartner, setOpenDropDownSeacrhForPlacePartner] = useState(false);
    const [quantidadeParceirosLista, setQuantidadeParceirosLista] = useState("");

    useEffect(() => {
        setLocationDistance(locationDistanceAroundMe)
    }, [locationDistance, aroundMe, locationDistanceAroundMe])

    useEffect(() => {
        isTablet ?
            setQuantidadeParceirosLista('8')
        :
            ( isMobile ?
                setQuantidadeParceirosLista('8')
                :
                setQuantidadeParceirosLista('3')
            )
    }, [isMobile, isTablet])

    const handleScroll = () => {
        setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, 300);
    };

    useEffect(() => {
        handleScroll();
    }, [pageNumber])
      
    const handleFocus = () => {
        setIsFocused(true);
        setOpenDropDownSeacrhForNamePartner(true)
    };
    
    const handleBlur = () => {
        setIsFocused(false);
        const delay = setTimeout(() => {
            setOpenDropDownSeacrhForNamePartner(false);
            setPageNumber(1);
            }, 500); 
    
            return () => clearTimeout(delay); 
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.target.blur();
            setSelectedSeacrhForNamePartner(true);
            setCallGetParceirosSeacrhForNamePartner(!callGetParceirosSeacrhForNamePartner);
            /* if (!selectedArrayPartnersName.includes(seacrhForNamePartner.trim())) {
                setSelectedArrayPartnersName([...selectedArrayPartnersName, seacrhForNamePartner.trim()]);
            } */
            if (!selectedArrayPartnersName.includes(seacrhForNamePartner.trim())) {
                setSelectedArrayPartnersName(seacrhForNamePartner.trim());
            }
        }
    };

    useEffect(() => {
        if (isCategoryState && category) {
            switch(category) {
                case 'Restauração e Supermercados':
                    setIsRestaurantStore(true);
                    break;
                case 'Saúde e Beleza':
                    setIsBeautyStore(true);
                    break;
                case 'Crianças e Educação':
                    setIsChildrenEducation(true);
                    break;
                case 'Cultura e Lazer':
                    setIsCultureLeisure(true);
                    break;
                case 'Desporto e Nutrição':
                    setIsSport(true);
                    break;
                case 'Tecnologia':
                    setIsTech(true);
                    break;
                case 'Moda e Casa':
                    setIsModaHome(true);
                    break;
                case 'Animais':
                    setIsAnimals(true);
                    break;
                case 'Mobilidade':
                    setIsCarsTransp(true);
                    break;
                case 'Alojamento e Viagens':
                    setIsAccommodationTravel(true);
                    break;
                case 'Sustentabilidade':
                    setIsSustainability(true);
                    break;
                case 'Outros':
                    setIsOther(true);
                    break;
                default:
                    setIsSustainability(false);
                    setIsAccommodationTravel(false);
                    setIsRestaurantStore(false);
                    setIsBeautyStore(false);
                    setIsChildrenEducation(false);
                    setIsCultureLeisure(false);
                    setIsSport(false);
                    setIsTech(false);
                    setIsModaHome(false);
                    setIsAnimals(false);
                    setIsCarsTransp(false);
                    setIsOther(false);
            }
            dispatchRedux(setCategoryState(false));
        }

        if (isCategoryState) {
            location.state.category = '';
        }
    }, [category, isCategoryState]);
    
    const handleFocusInputSeacrhForPlace = () => {
        setIsFocusedInputSeacrhForPlace(true);
        setOpenDropDownSeacrhForPlacePartner(true)
    };
    
    const handleBlurInputSeacrhForPlace = () => {
        setIsFocusedInputSeacrhForPlace(false);
        const delay = setTimeout(() => {
            setOpenDropDownSeacrhForPlacePartner(false);
            setPageNumber(1);
            }, 500); 
    
            return () => clearTimeout(delay); 
    };

    const handleKeyDownInputSeacrhForPlace = (event) => {
        if (event.key === "Enter") {
            event.target.blur();
            setSelectedSeacrhForPlacePartner(true);
            setCallGetParceirosSeacrhForPlacePartner(!callGetParceirosSeacrhForPlacePartner);
        }
    };
    
    const renderIconByItem = (item) => {
        const iconType =  getIconType(item.categoria);
        return iconType;
    };

    const handleCheckboxChangeOne = () => {
        setIsAccommodationTravel(!isAccommodationTravel);
        setPageNumber(1);
    };

    const handleCheckboxChangeTwo = () => {
        setIsSport(!isSport);
        setPageNumber(1);
    };

    const handleCheckboxChangeThree = () => {
        setIsBeautyStore(!isBeautyStore);
        setPageNumber(1);
    };

    const handleCheckboxChangeFour = () => {
        setIsChildrenEducation(!isChildrenEducation);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeFive = () => {
        setIsCultureLeisure(!isCultureLeisure);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeSix = () => {
        setIsTech(!isTech);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeSeven = () => {
        setIsModaHome(!isModaHome);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeEight = () => {
        setIsAnimals(!isAnimals);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeNine = () => {
        setIsCarsTransp(!isCarsTransp);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeTen = () => {
        setIsOther(!isOther);
        setPageNumber(1);
    };

    const handleCheckboxChangeEleven = () => {
        setIsRestaurantStore(!isRestaurantStore);
        setPageNumber(1);
    };

    const handleCheckboxChangeTwelve = () => {
        setIsSustainability(!isSustainability);
        setPageNumber(1);
    };

    const handleCheckboxChangeStoreOnline = () => {
        setIsStoreOnline(!isStoreOnline);
        setPageNumber(1);
    };

    const handleCheckboxChangeStorePhysical = () => {
        setIsStorePhysical(!isStorePhysical);
        setPageNumber(1);
    };
    
    const handleCheckboxChangeNew = () => {
        setIsNew(!isNew);
        setPageNumber(1);
    };

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleClickShowInfo = () => {
       setOpenInfoModal(true)
    };

    const handleClickSearchPartner = () => {
        //alert('Search Partner')
    }

    useEffect(() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            position => {
              const { latitude, longitude } = position.coords;
              setMyLocation({ latitude, longitude });
            },
            error => {
                toast.dismiss();
                toast.error("Erro ao obter localização. Por favor, tente mais tarde.", {
                    icon: <AiOutlineStop/>
                });
            }
          );
        } else {
            toast.dismiss();
            toast.error("A geolocalização não é suportada pelo seu navegador!", {
                icon: <AiOutlineStop/>
            });
        }
    }, []);

    const handleClearFilter  = () => {
        setIsSustainability(false);
        setIsAccommodationTravel(false);
        setIsSport(false);
        setIsBeautyStore(false);
        setIsChildrenEducation(false);
        setIsCultureLeisure(false);
        setIsTech(false);
        setIsModaHome(false);
        setIsAnimals(false);
        setIsCarsTransp(false);
        setIsOther(false);
        setLocationDistance(MIN);
        setLocationDistanceAroundMe(MIN);
        setSeacrhForNamePartner('');
        setSeacrhForPlacePartner('');
        setIsStoreOnline(false);
        setIsStorePhysical(false);
        setIsNew(false);
        setIsRestaurantStore(false);
        setPageNumber(1);
        handleClearAllFilters();
        navigate(location.pathname, {
            state: { ...location.state, seacrhCategory: '', aroundMe: MIN }, 
            replace: true 
        });
        setSelectedArrayPartnersName('');
        setSeacrhCategoryFiltr('');
    };

    const handleEnabledBtnFilter = () => {
        return (
            seacrhForNamePartner.length > 0 ||
            seacrhForPlacePartner.length > 0 ||
            !!isSustainability ||
            !!isAccommodationTravel ||
            !!isSport ||
            !!isBeautyStore ||
            !!isChildrenEducation ||
            !!isCultureLeisure ||
            !!isTech ||
            !!isModaHome ||
            !!isAnimals ||
            !!isCarsTransp ||
            !!isOther ||
            !!locationDistance > MIN  ||
            !!isStoreOnline ||
            !!isStorePhysical ||
            !!isNew ||
            !!isRestaurantStore ||
            !!selectedArrayItems.length > 0 ||
            !!seacrhCategory.length > 0 ||
            !!aroundMe > 0 ||
            !!seacrhCategoryFiltr.length > 0
        );
    };

    const handleOpenFilterModal = () => {
        setOpenSelectFilteModal(true)
    };

    const onHide = () => {
        setOpenSelectFilteModal(false)
    };

    const handleNavBoxClick = (item) => {
        const categoryStore = item.nomeparceiro.toLowerCase();
        navigate(location.pathname, {
            state: { ...location.state, seacrhCategory: '', aroundMe: MIN }, 
            replace: true 
        });
        navigate(`/ganhar-saldo/parceiros/catalogo-de-parceiros/${categoryStore}`, { state: { item } })
    };
    

    const marks = [
        {
            value: 0,
            label: '0',
        },
        {
            value: 5,
            label: '5',
        },
        {
            value: 10,
            label: '10',
        },
        {
            value: 15,
            label: '15',
        },
        {
            value: 20,
            label: '20Km',
        },
    ];

    const filters = [
        { name: "Restauração e Supermercados", state: isRestaurantStore, setState: setIsRestaurantStore },
        { name: "Saúde e Beleza", state: isBeautyStore, setState: setIsBeautyStore },
        { name: "Crianças e Educação", state: isChildrenEducation, setState: setIsChildrenEducation },
        { name: "Cultura e Lazer", state: isCultureLeisure, setState: setIsCultureLeisure },
        { name: "Desporto e Nutrição", state: isSport, setState: setIsSport },
        { name: "Tecnologia", state: isTech, setState: setIsTech },
        { name: "Moda e Casa", state: isModaHome, setState: setIsModaHome },
        { name: "Animais", state: isAnimals, setState: setIsAnimals },
        { name: "Mobilidade", state: isCarsTransp, setState: setIsCarsTransp },
        { name: "Alojamento e Viagens", state: isAccommodationTravel, setState: setIsAccommodationTravel },
        { name: "Sustentabilidade", state: isSustainability, setState: setIsSustainability },
        { name: "Outros", state: isOther, setState: setIsOther },
        { name: "Mostrar apenas novidades", state: isNew, setState: setIsNew },
        { name: "Loja física", state: isStoreOnline, setState: setIsStoreOnline },
        { name: "Loja online", state: isStorePhysical, setState: setIsStorePhysical },
    ]

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedArrayItems, setSelectedArrayItems] = useState([]);

    const [selectedItems, dispatch] = useReducer(filterReducer, []);

    const handleCheckboxChange = (event, item) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            dispatch({ type: "TOGGLE_SELECT", id: item.code, name: item.name, checked: true });
        } else {
            const updatedSelectedItems = selectedItems.filter(selectedItem => selectedItem.code !== item.code);
            dispatch({ type: "SET_SELECTED_ITEMS", selectedItems: updatedSelectedItems });
        }
    };
       

    useEffect(() => {
        const selectedNames = selectedItems.map(item => item.name);
        setSelectedArrayItems(selectedNames);
        setPageNumber(1);
    }, [selectedItems])

    const handleCancelFilter = (itemName) => {
        const updatedSelectedItems = selectedItems.filter(item => item.name !== itemName);
        dispatch({ type: "SET_SELECTED_ITEMS", selectedItems: updatedSelectedItems });
    };
      
    const handleClearAllFilters = () => {
        dispatch({ type: "SET_SELECTED_ITEMS", selectedItems: [] });
    }; 
    
    const isCheckedConselhos  = (item) => {
        return  selectedItems.some(selectedItem => selectedItem.code === item.code && selectedItem.checked);
    };

    const handleSeacrhForNamePartner = (item) => {
        setSeacrhForNamePartner(item)
        setSelectedSeacrhForNamePartner(true);
        setCallGetParceirosSeacrhForNamePartner(!callGetParceirosSeacrhForNamePartner);
        /* if (!selectedArrayPartnersName.includes(item.trim())) {
            setSelectedArrayPartnersName([...selectedArrayPartnersName, item.trim()]);
        } */
        if (!selectedArrayPartnersName.includes(item.trim())) {
            setSelectedArrayPartnersName(item.trim());
        }
    }

    const highlightMatchedText = (text, query) => {
        if (!query) return text;
    
        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);
    
        return parts.map((part, index) =>
            regex.test(part) ? (
                <span key={index} className="highlightPartnersPage">{part}</span>
            ) : (
                part
            )
        );
    };
    

    const [filteredPartners, setFilteredPartners] = useState([]);
    const [filteredPartnersPlace, setFilteredPartnersPlace] = useState([]);
    const [selectedArrayPartnersName, setSelectedArrayPartnersName] = useState('');

    const handleCancelFilterPartnersName = () => {
        //setSelectedArrayPartnersName(selectedArrayPartnersName.filter(item => item !== itemName));
        setSelectedArrayPartnersName('')
        setSeacrhForNamePartner('');
        setSelectedSeacrhForNamePartner(false);
        setCallGetParceirosSeacrhForNamePartner(!callGetParceirosSeacrhForNamePartner);
    };
    

    const handleInputSeacrhForNamePartner = (event) => {
        const newValue = event.target.value;
        setSeacrhForNamePartner(newValue);
        if (newValue.length > 0) {
            setSelectedSeacrhForNamePartner(false);
            const filtered = nomesParceirosList?.filter(partner => 
                partner.toLowerCase().includes(newValue.toLowerCase())
            );
            setFilteredPartners(filtered);
        } 
        else if (newValue.length === 0) {
            setSelectedSeacrhForNamePartner(false);
        } else {
            setFilteredPartners([]);
        }
    };

    const handleSeacrhForPlacePartner = (item) => {
        setSeacrhForPlacePartner(item)
        setSelectedSeacrhForPlacePartner(true);
        setCallGetParceirosSeacrhForPlacePartner(!callGetParceirosSeacrhForPlacePartner);
    }
    

    const handleInputSeacrhForPlaceChange = (event) => {
        const newValue = event.target.value.replace(/\d/g, '');
        setSeacrhForPlacePartner(newValue);
    
        if (newValue.length > 0) {
            setSelectedSeacrhForPlacePartner(false);
            const uniqueNames = new Map();
    
            portugalLocationsData.portugalLocations?.forEach(partner => {
                // Add the top-level district name to the map if it matches
                if (partner.name.toLowerCase().includes(newValue.toLowerCase())) {
                    uniqueNames.set(partner.name, 'district');
                }
    
                // Add "conselhos" names to the map only if they are not already in it
                partner.conselhos?.forEach(conselho => {
                    if (
                        conselho.name.toLowerCase().includes(newValue.toLowerCase()) &&
                        !uniqueNames.has(conselho.name)
                    ) {
                        uniqueNames.set(conselho.name, 'conselho');
                    }
                });
            });
    
            // Get only the keys (names) from the map
            const filteredNames = Array.from(uniqueNames.keys());
            setFilteredPartnersPlace(filteredNames);
        } else if (newValue.length === 0) {
            setSelectedSeacrhForPlacePartner(false);
        } else {
            setFilteredPartnersPlace([]);
        }
    };
    


    const fetchCSRFToken = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
            });
            const data = await response.json();
            const csrfToken = data.csrfToken;

            return csrfToken;
        } catch (error) {
            errorHandling('CSRF');
        }
    };

    const getParceiros = async () => {
        setIsLoadingList(true);
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/getParceiros/fetchGetParceiros`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                "xsrf-token": csrfToken,
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({ 
                nomeParceiro: (seacrhForNamePartner.length >= 1 && selectedSeacrhForNamePartner) ? seacrhForNamePartner : "",
                codPostalLocalidade: (seacrhForPlacePartner.length >= 1 && selectedSeacrhForPlacePartner && !isFocusedInputSeacrhForPlace) ? seacrhForPlacePartner : "",
                localidadeOuParceiro: seacrhCategory,
                distrito: "",
                concelhos: selectedArrayItems,
                popup: myLocation !== '' ? true : false,
                longitude: `${myLocation.longitude}`,
                latitude: `${myLocation.latitude}`,
                proximidade: aroundMe > 0 ? aroundMe : locationDistance,
                iAlojamentoViagem: `${isAccommodationTravel}`,
                iDesporto: `${isSport}`,
                iSaudeBeleza: `${isBeautyStore}`,
                iCriancasEducacao: `${isChildrenEducation}`,
                iCulturaLazer: `${isCultureLeisure}`,
                iTecnologia: `${isTech}`,
                iModaCasa: `${isModaHome}`,
                iAnimais: `${isAnimals}`,
                iVeiculosTransportes: `${isCarsTransp}`,
                iRestauracaoSupermercado: `${isRestaurantStore}`,
                iSustentabilidade: `${isSustainability}`,
                iOutros: `${isOther}`,
                iFisica: `${isStorePhysical}`,
                iOnline: `${isStoreOnline}`,
                iNovidades: `${isNew}`,
                pagParceiros: pageNumber,
                quantidadeParceirosLista: quantidadeParceirosLista
            }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setListaParceirosResp(result.parceiros)
                setNumeroDePaginas(result.numeroDePaginasParceiros);
                setCountAccommodationTravel(result.nAlojamentoViagens);
                setCountSustainability(result.nSustentabilidade);
                setCountSport(result.nDesporto);
                setCountBeautyStore(result.nSaudeBeleza);
                setCountChildrenEducation(result.nCriancasEducacao);
                setCountCultureLeisure(result.nCulturaLazer);
                setCountTech(result.nTecnologia);
                setCountModaHome(result.nModaCasa);
                setCountAnimals(result.nAnimais);
                setCountCarsTransp(result.nVeiculosTransporte);
                setCountOther(result.nOutros);
                setCountRestaurantStore(result.nRestauracaoSupermercado);
                setCountStoreOnline(result.nOnline);
                setCountStorePhysical(result.nFisica);
                setCountNew(result.nNovidades);
                setNomesParceirosList(result.nomesParceiros);
                setNumeroDeOcorrenciasParceiros(result.numeroTotalDeParceiros);
                setIsLoadingList(false);
                setSeacrhCategoryFiltr(seacrhCategory);
                navigate(location.pathname, {
                    state: { ...location.state, seacrhCategory: '', aroundMe: MIN }, 
                    replace: true 
                });
            }
        } catch (error) {
            setIsLoadingList(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }
    
    useEffect(() => {
        if (isLoading === false) {
            getParceiros();
        }
    }, [myLocation, callGetParceirosSeacrhForNamePartner, category, callGetParceirosSeacrhForPlacePartner, locationDistance, isAccommodationTravel, isSustainability, isSport, isBeautyStore, isChildrenEducation, isCultureLeisure, isTech, isAnimals, isModaHome, isCarsTransp, isRestaurantStore, isOther, isStorePhysical, isStoreOnline, isNew, pageNumber, selectedArrayItems, quantidadeParceirosLista, isLoading]); 
        
    const handkeChangeMaxLength = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    const inputClassName = isTablet ? 'inputTextPartnersPage': ( isMobile ? 'inputTextPartnersPage' : 'inputTextPartnersPageMobile');
    const inputClassNameFocus = isTablet ? 'inputTextPartnersPage focused': ( isMobile ? 'inputTextPartnersPage focused' : 'inputTextPartnersPageMobile focused');

    const handleBtnGoToContacts = () => {
        navigate('/configuracoes#contactMainContainer');
    };

    return (  
        <>
        <Header/> 
        { isLoading ? 
            <GifAnim />
        :
        <>
        {/* Start fist div componet with title / header */}
        <div className={ isTablet ? "mainViewContainerPartnersPage" : ( isMobile ? 'mainViewContainerPartnersPageTablet' : 'mainViewContainerPartnersPageMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerPartnersPage' : ( isMobile ? 'firstTxtViewContainerPartnersPageTablet' : 'firstTxtViewContainerPartnersPageMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%' } : { width: '100%', height: '100%' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div> 
                <div className='mainHeadingViewContainerPartnersPage'> 
                    <CustomBreadcrumbs hasPartnerCatalog hasEarnBalance />
                    <Heading hasBtnBack={false}/>
                </div>
                {/* End fist div componet with title / header */}

                <div className={ isTablet ? 'secondMainContainerPartnersPage' : 'secondMainContainerPartnersPageMobile' }>
                    <div className={ isTablet ? 'firstSubMainContainerPartnersPage' : 'firstSubMainContainerPartnersPageMobile' }>
                        <div className={ isTablet ? 'mainOptionsViewContainerPartnersPage' : 'mainOptionsViewContainerPartnersPageMobile' }>
                            {/* Start fourth div componet with filters */}
                            { isTablet ? (
                                <>
                                <div className='mainOptionsColumnViewContainerPartnersPage'>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div className='txtFirstOptionsTitlePartnersPage'>Pesquise parceiros</div>
                                    </div>
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='textWrapperGapPartnersPage'>
                                        <div className='textWrapperPartnersPage'>
                                            { (isFocused || seacrhForNamePartner.length > 0) &&
                                                <label className='label-focusPartnersPage'>Nome do parceiro</label>
                                            }
                                            <input 
                                                className={ seacrhForNamePartner.length > 0 ? inputClassNameFocus : inputClassName}
                                                type="text" 
                                                placeholder={ !isFocused ? 'Nome do parceiro' : undefined}
                                                value={seacrhForNamePartner}
                                                onChange={handleInputSeacrhForNamePartner}
                                                maxLength={50}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                onKeyDown={handleKeyDown}
                                                autoComplete='off'
                                                spellCheck="false"
                                                inputMode='text'

                                            />
                                            <div className='findIconViewPartnersPage' onClick={handleClickSearchPartner}><IoSearch className='findIconPartnersPage' /></div>
                                        </div>
                                        {(seacrhForNamePartner.length > 0 && !selectedSeacrhForNamePartner && openDropDownSeacrhForNamePartner)  && (
                                        <>
                                            <div className={filteredPartners.length > 3 ? 'textWrapperViewCollumnPartnersPage' : 'textWrapperSmallViewCollumnPartnersPage'}  style={{marginTop: '-20px'}}>
                                                <div className={ filteredPartners.length > 1 ? 'textWrapperCollumnPartnersPage' : 'textWrapperNoScrollCollumnPartnersPage'}>
                                                    {filteredPartners?.map((item, index)=>(
                                                        <div key={index} className="searchPosCodListViewPartnersPage">
                                                            <button  className='txtSelectPlaceBtnPartnersPage' onClick={() => handleSeacrhForNamePartner(item)}>
                                                                {highlightMatchedText(item, seacrhForNamePartner)}
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                        )}
                                        {(selectedArrayPartnersName.length > 0) && (
                                            <div className='selectedFiltersScrollViewContainerPartnersPage'>
                                                {/* {selectedArrayPartnersName.map((itemName, index) => (
                                                    <button key={index} className='btnSelectedFilterItemPartnersPage' onClick={() => handleCancelFilterPartnersName(itemName)}>
                                                        <div className="txtBtnSelectedFilterItemPartnersPage">{itemName}</div>
                                                        <div style={{ display: 'flex'}}><IoMdClose className="iconBtnSelectedFilterItemPartnersPage"/></div>
                                                    </button>
                                                ))} */}
                                                <button className='btnSelectedFilterItemPartnersPage' onClick={() => handleCancelFilterPartnersName()}>
                                                    <div className="txtBtnSelectedFilterItemPartnersPage">{selectedArrayPartnersName}</div>
                                                    <div style={{ display: 'flex'}}><IoMdClose className="iconBtnSelectedFilterItemPartnersPage"/></div>
                                                </button>
                                            </div>
                                        )}
                                        <div>
                                            <span className='txtInfoGrennOptionsBoldTitlePartnersPage'>{numeroDeOcorrenciasParceiros} </span>
                                            <span className='txtInfoGrennOptionsRegularTitlePartnersPage'>
                                                {numeroDeOcorrenciasParceiros.length === 1 ? 'resultado encontrado' : 'resultados encontrados'}
                                            </span>
                                            <span className='txtInfoGrennOptionsRegularTitlePartnersPage'>. Use os filtros para refinar melhor a sua pesquisa</span>
                                        </div>
                                    </div>
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div style={{ marginBottom: '24px'}}>
                                            <div className='txtFirstOptionsTitlePartnersPage'>Por localização</div>
                                        </div>
                                        <div className='textWrapperPartnersPage'>
                                            { (isFocusedInputSeacrhForPlace || seacrhForPlacePartner.length > 0) &&
                                                <label className='label-focusPartnersPage'>Localidade</label>
                                            }
                                            <input 
                                                className={ seacrhForPlacePartner.length > 0 ? inputClassNameFocus : inputClassName}
                                                type="text" 
                                                placeholder={ !isFocusedInputSeacrhForPlace ? 'Localidade' : undefined}
                                                value={seacrhForPlacePartner}
                                                onChange={handleInputSeacrhForPlaceChange}
                                                onFocus={handleFocusInputSeacrhForPlace}
                                                onBlur={handleBlurInputSeacrhForPlace}
                                                onKeyDown={handleKeyDownInputSeacrhForPlace}
                                                autoComplete='off'
                                                spellCheck="false"
                                                inputMode='text'
                                            />
                                        </div>
                                        {(seacrhForPlacePartner.length > 0 && !selectedSeacrhForPlacePartner && openDropDownSeacrhForPlacePartner)  && (
                                        <>
                                            <div className={filteredPartnersPlace.length > 3 ? 'textWrapperViewCollumnPartnersPage' : 'textWrapperSmallViewCollumnPartnersPage'} style={{marginTop: '16px'}}>
                                                <div className={ filteredPartnersPlace.length > 1 ? 'textWrapperCollumnPartnersPage' : 'textWrapperNoScrollCollumnPartnersPage'}>
                                                    {filteredPartnersPlace?.map((item, index)=>(
                                                        <div key={index} className="searchPosCodListViewPartnersPage">
                                                            <button  className='txtSelectPlaceBtnPartnersPage' onClick={() => handleSeacrhForPlacePartner(item)}>
                                                                {highlightMatchedText(item, seacrhForPlacePartner)}
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                        )}
                                    </div>
                                    { myLocation !== '' &&
                                        <div style={{width: '100%', maxWidth: '350px', height: '100%', paddingLeft: '5px', paddingRight: '15px'}}>
                                            <Slider
                                                size="small"
                                                value={locationDistance}
                                                min={MIN}
                                                step={1}
                                                max={MAX}
                                                marks={marks}
                                                onChange={(_, value) => setLocationDistanceAroundMe(value)}
                                                sx={{
                                                    color: theme.palette.mode === 'dark' ? '#141414' : '#141414',
                                                    height: 4,
                                                    '& .MuiSlider-thumb': {
                                                    width: 10,
                                                    height: 10,
                                                    transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
                                                    '&::before': {
                                                        boxShadow: '0 2px 12px 0 rgba(0,0,0,0.4)',
                                                    },
                                                    '&:hover, &.Mui-focusVisible': {
                                                        boxShadow: `0px 0px 0px 8px ${
                                                        theme.palette.mode === 'dark'
                                                            ? '#14141410'
                                                            : '#14141410'
                                                        }`,
                                                    },
                                                    '&.Mui-active': {
                                                        width: 14,
                                                        height: 14,
                                                    },
                                                    },
                                                    '& .MuiSlider-rail': {
                                                    opacity: 0.28,
                                                    },
                                                }}
                                            /> 
                                        </div>                                    
                                    }
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div style={{ marginBottom: '24px'}}>
                                            <div className='txtFirstOptionsTitlePartnersPage'>Por categoria</div>
                                        </div>
                                        <Form>
                                            <div className='firstOptionsFormChekedViewPartnersPage'>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isAccommodationTravel}
                                                        onChange={handleCheckboxChangeOne}
                                                        disabled={countAccommodationTravel <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countAccommodationTravel > 0 ? handleCheckboxChangeOne : null} style={{cursor: countAccommodationTravel > 0 ? 'pointer' : 'default'}}>{`Alojamento e Viagens (${countAccommodationTravel})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isSustainability}
                                                        onChange={handleCheckboxChangeTwelve}
                                                        disabled={countSustainability <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countSustainability > 0 ? handleCheckboxChangeTwelve : null} style={{cursor: countSustainability > 0 ? 'pointer' : 'default'}}>{`Sustentabilidade (${countSustainability})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isSport}
                                                        onChange={handleCheckboxChangeTwo}
                                                        disabled={countSport <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countSport > 0 ? handleCheckboxChangeTwo : null} style={{cursor: countSport > 0 ? 'pointer' : 'default'}}>{`Desporto e Nutrição (${countSport})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isBeautyStore}
                                                        onChange={handleCheckboxChangeThree}
                                                        disabled={countBeautyStore <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ isBeautyStore > 0 ? handleCheckboxChangeThree : null} style={{cursor: isBeautyStore > 0 ? 'pointer' : 'default'}}>{`Saúde e Beleza (${countBeautyStore})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isChildrenEducation}
                                                        onChange={handleCheckboxChangeFour}
                                                        disabled={countChildrenEducation <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countChildrenEducation > 0 ? handleCheckboxChangeFour : null} style={{cursor: countChildrenEducation > 0 ? 'pointer' : 'default'}}>{`Crianças e Educação (${countChildrenEducation})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isCultureLeisure}
                                                        onChange={handleCheckboxChangeFive}
                                                        disabled={countCultureLeisure <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countCultureLeisure > 0 ? handleCheckboxChangeFive : null} style={{cursor: countCultureLeisure > 0 ? 'pointer' : 'default'}}>{`Cultura e Lazer (${countCultureLeisure})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isTech}
                                                        onChange={handleCheckboxChangeSix}
                                                        disabled={countTech <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countTech > 0 ? handleCheckboxChangeSix : null} style={{cursor: countTech > 0 ? 'pointer' : 'default'}}>{`Tecnologia (${countTech})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isModaHome}
                                                        onChange={handleCheckboxChangeSeven}
                                                        disabled={countModaHome <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countModaHome > 0 ? handleCheckboxChangeSeven : null} style={{cursor: countModaHome > 0 ? 'pointer' : 'default'}}>{`Moda e Casa (${countModaHome})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isAnimals}
                                                        onChange={handleCheckboxChangeEight}
                                                        disabled={countAnimals <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countAnimals > 0 ? handleCheckboxChangeEight : null} style={{cursor: countAnimals > 0 ? 'pointer' : 'default'}}>{`Animais (${countAnimals})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isCarsTransp}
                                                        onChange={handleCheckboxChangeNine}
                                                        disabled={countCarsTransp <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countCarsTransp > 0 ? handleCheckboxChangeNine : null} style={{cursor: countCarsTransp > 0 ? 'pointer' : null}}>{`Mobilidade (${countCarsTransp})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isRestaurantStore}
                                                        onChange={handleCheckboxChangeEleven}
                                                        disabled={countRestaurantStore <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countRestaurantStore > 0 ? handleCheckboxChangeEleven : null} style={{cursor: countRestaurantStore > 0 ? 'pointer' : 'default'}}>{`Restauração e Supermercados (${countRestaurantStore})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isOther}
                                                        onChange={handleCheckboxChangeTen}
                                                        disabled={countOther <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countOther > 0 ? handleCheckboxChangeTen : null} style={{cursor: countOther > 0 ? 'pointer' : 'default'}}>{`Outros (${countOther})`}</div>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div style={{ marginBottom: '24px'}}>
                                            <div className='txtFirstOptionsTitlePartnersPage'>Opção de compra</div>
                                        </div>
                                        <Form>
                                            <div className='firstOptionsFormChekedViewPartnersPage'>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isStorePhysical}
                                                        onChange={handleCheckboxChangeStorePhysical}
                                                        disabled={countStorePhysical <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countStorePhysical > 0 ? handleCheckboxChangeStorePhysical : null} style={{cursor: countStorePhysical > 0 ? 'pointer' : 'default'}}>{`Loja física (${countStorePhysical})`}</div>
                                                </div>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isStoreOnline}
                                                        onChange={handleCheckboxChangeStoreOnline}
                                                        disabled={countStoreOnline <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countStoreOnline > 0 ? handleCheckboxChangeStoreOnline : null} style={{cursor: countStoreOnline > 0 ? 'pointer' : 'default'}}>{`Loja online (${countStoreOnline})`}</div>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div style={{ marginBottom: '24px'}}>
                                            <div className='txtFirstOptionsTitlePartnersPage'>Novas parcerias</div>
                                        </div>
                                        <Form>
                                            <div className='firstOptionsFormChekedViewPartnersPage'>
                                                <div className='firstOptionsRowFormChekedViewPartnersPage'>
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        label={''}
                                                        checked={isNew}
                                                        onChange={handleCheckboxChangeNew}
                                                        disabled={countNew <= '0'}
                                                    />
                                                    <div className='txtFormPartnersPage' onClick={ countNew > 0 ? handleCheckboxChangeNew : null} style={{cursor: countNew > 0 ? 'pointer' : 'default'}}>{`Mostrar apenas novidades (${countNew})`}</div>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                    <div className='optionsDeviderLinePartnersPage'></div>
                                    <CustomButton 
                                        text={'Remover filtros'} 
                                        textColor={'#00214D'}
                                        onPress={handleClearFilter}
                                        enabled={handleEnabledBtnFilter()}
                                        color={'#fff'}
                                        borderColor={'#00214D'}
                                        hasShadow={false}
                                    />
                                </div>
                                </>
                            ) : (
                                <div className='mainOptionsColumnViewContainerPartnersPageMobile'>
                                    <div className='txtFirstOptionsTitleViewPartnersPage'>
                                        <div className='txtFirstOptionsTitlePartnersPage'>Pesquise parceiros</div>
                                    </div>
                                    <div className='mainOptionsRowViewContainerPartnersPageMobile'>
                                        <div className='textWrapperPartnersPage'>
                                            { (isFocused || seacrhForNamePartner.length > 0) &&
                                                <label className='label-focusPartnersPage'>Nome do parceiro</label>
                                            }
                                            <input 
                                                className={ seacrhForNamePartner.length > 0 ? inputClassNameFocus : inputClassName}
                                                type="text" 
                                                placeholder={ !isFocused ? 'Nome do parceiro' : undefined}
                                                value={seacrhForNamePartner}
                                                onChange={handleInputSeacrhForNamePartner}
                                                maxLength={50}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                onKeyDown={handleKeyDown}
                                                autoComplete='off'
                                                spellCheck="false"
                                                inputMode='text'
                                            />
                                            <div className={ isTablet ? 'findIconViewPartnersPage' : (isMobile ? 'findIconViewPartnersPage' : 'findIconViewPartnersPageMobile')} onClick={handleClickSearchPartner}><IoSearch className='findIconPartnersPage' /></div>
                                        </div>
                                        <button className='filterIconViewPartnersPageMobile' onClick={handleOpenFilterModal}><CiFilter className='filterIconPartnersPage'/></button>
                                        <CustomFilterModal 
                                            title='Filter'
                                            show={openSelectFilteModal} 
                                            onHide={onHide} 
                                            fullscreen
                                            seacrhForNamePartner={seacrhForNamePartner}
                                            setSeacrhForNamePartner={setSeacrhForNamePartner}
                                            handleClickShowInfo={handleClickShowInfo}
                                            partnersListMock={listaParceirosResp}
                                            nomesParceirosList={nomesParceirosList}
                                            seacrhForPlacePartner={seacrhForPlacePartner}
                                            setSeacrhForPlacePartner={setSeacrhForPlacePartner}
                                            locationDistance={locationDistance}
                                            marks={marks}
                                            min={MIN}
                                            max={MAX}
                                            setLocationDistance={setLocationDistance}
                                            theme={theme}
                                            countAccommodationTravel={countAccommodationTravel}
                                            countSustainability={countSustainability}
                                            isAccommodationTravel={isAccommodationTravel}
                                            isSustainability={isSustainability}
                                            handleCheckboxChangeOne={handleCheckboxChangeOne}
                                            handleCheckboxChangeTwelve={handleCheckboxChangeTwelve}
                                            countSport={countSport}
                                            isSport={isSport}
                                            handleCheckboxChangeTwo={handleCheckboxChangeTwo}
                                            countBeautyStore={countBeautyStore}
                                            isBeautyStore={isBeautyStore}
                                            handleCheckboxChangeThree={handleCheckboxChangeThree}
                                            countChildrenEducation={countChildrenEducation}
                                            isChildrenEducation={isChildrenEducation}
                                            handleCheckboxChangeFour={handleCheckboxChangeFour}
                                            countCultureLeisure={countCultureLeisure}
                                            isCultureLeisure={isCultureLeisure}
                                            handleCheckboxChangeFive={handleCheckboxChangeFive}
                                            countTech={countTech}
                                            isTech={isTech}
                                            handleCheckboxChangeSix={handleCheckboxChangeSix}
                                            countModaHome={countModaHome}
                                            isModaHome={isModaHome}
                                            handleCheckboxChangeSeven={handleCheckboxChangeSeven}
                                            countAnimals={countAnimals}
                                            isAnimals={isAnimals}
                                            handleCheckboxChangeEight={handleCheckboxChangeEight}
                                            countCarsTransp={countCarsTransp}
                                            isCarsTransp={isCarsTransp}
                                            handleCheckboxChangeNine={handleCheckboxChangeNine}
                                            countRestaurantStore={countRestaurantStore}
                                            isRestaurantStore={isRestaurantStore}
                                            handleCheckboxChangeEleven={handleCheckboxChangeEleven}
                                            countOther={countOther}
                                            isOther={isOther}
                                            handleCheckboxChangeTen={handleCheckboxChangeTen}
                                            countStoreOnline={countStoreOnline}
                                            isStoreOnline={isStoreOnline}
                                            handleCheckboxChangeStoreOnline={handleCheckboxChangeStoreOnline}
                                            countStorePhysical={countStorePhysical}
                                            isStorePhysical={isStorePhysical}
                                            handleCheckboxChangeStorePhysical={handleCheckboxChangeStorePhysical}
                                            countNew={countNew}
                                            isNew={isNew}
                                            handleCheckboxChangeNew={handleCheckboxChangeNew}
                                            handleClearFilter={handleClearFilter}
                                            handleEnabledBtnFilter={handleEnabledBtnFilter}
                                            selectedItem={selectedItem}
                                            setSelectedItem={setSelectedItem}
                                            selectedArrayItems={selectedArrayItems}
                                            handleCheckboxChange={handleCheckboxChange}
                                            handleCancelFilter={handleCancelFilter}
                                            filters={filters}
                                            isCheckedConselhos={isCheckedConselhos}
                                            filteredPartnersPlace={filteredPartnersPlace}
                                            setFilteredPartnersPlace={setFilteredPartnersPlace}
                                            selectedSeacrhForPlacePartner={selectedSeacrhForPlacePartner}
                                            setSelectedSeacrhForPlacePartner={setSelectedSeacrhForPlacePartner}
                                            setPageNumber={setPageNumber}
                                        />  
                                    </div>
                                    {(seacrhForNamePartner.length > 0 && !selectedSeacrhForNamePartner && openDropDownSeacrhForNamePartner)  && (
                                    <>
                                        <div className={filteredPartners.length > 3 ? 'textWrapperViewCollumnPartnersPage' : 'textWrapperSmallViewCollumnPartnersPage'} style={{marginTop: '-5px'}}>
                                            <div className={ filteredPartners.length > 1 ? 'textWrapperCollumnPartnersPage' : 'textWrapperNoScrollCollumnPartnersPage'}>
                                                {filteredPartners?.map((item, index)=>(
                                                    <div key={index} className="searchPosCodListViewPartnersPage">
                                                        <button  className='txtSelectPlaceBtnPartnersPage' onClick={() => handleSeacrhForNamePartner(item)}>
                                                            {highlightMatchedText(item, seacrhForNamePartner)}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                    )}
                                    {/* <div>
                                        <span className='txtInfoGrennOptionsBoldTitlePartnersPage'>{numeroDeOcorrenciasParceiros} </span>
                                        <span className='txtInfoGrennOptionsRegularTitlePartnersPage'>resultados encontrados. Use os filtros para refinar melhor a sua pesquisa</span>
                                    </div> */}
                                    <div className='selectedFiltersScrollViewContainerPartnersPage'>
                                        {selectedArrayItems.map((itemName, index) => (
                                            <button key={index} className='btnSelectedFilterItemPartnersPage' onClick={() => handleCancelFilter(itemName)}>
                                                <div className="txtBtnSelectedFilterItemPartnersPage">{itemName}</div>
                                                <div style={{ display: 'flex'}}><IoMdClose className="iconBtnSelectedFilterItemPartnersPage"/></div>
                                            </button>
                                        ))}
                                        {filters.map((filter, index) => (
                                            filter.state && (
                                            <button key={index} className='btnSelectedFilterItemPartnersPage' onClick={() => {filter.setState(false); setPageNumber(1);}}>
                                                <div className="txtBtnSelectedFilterItemPartnersPage">{filter.name}</div>
                                                <div style={{ display: 'flex'}}><IoMdClose className="iconBtnSelectedFilterItemPartnersPage"/></div>
                                            </button>
                                            )
                                        ))}
                                        {(seacrhForPlacePartner.length > 0 && !isTablet) && (
                                            <button className='btnSelectedFilterItemPartnersPage' onClick={() => {setSeacrhForPlacePartner(''); setSelectedSeacrhForPlacePartner(false); setPageNumber(1);}}>
                                                <div className="txtBtnSelectedFilterItemPartnersPage">{seacrhForPlacePartner}</div>
                                                <div style={{ display: 'flex'}}><IoMdClose className="iconBtnSelectedFilterItemPartnersPage"/></div>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* End fourth div componet with filters */}

                            {/* Start fifth div componet with info blocks list */}
                            { isLoadingList ? 
                                <div className='GifAnimMainViewContainerPartnersPage'>
                                    <div className='manImgViewContainerGifAnimPartnersPage'>
                                        <img src={GifIconLoading} alt="gif" className='mainGifContainerGifAnim'/>
                                    </div>
                                </div>
                            :
                            <>
                                {listaParceirosResp?.length > 0 ? (
                                    <div className={ isTablet ? 'mainOptionsSecondColumnViewContainerPartnersPage' : ( isMobile ? 'mainOptionsSecondColumnViewContainerPartnersPageTablet' : 'mainOptionsSecondColumnViewContainerPartnersPageMobile') }>
                                        {listaParceirosResp.map((item, index) => (
                                            <button className={ isTablet ? 'mainOptionsMainColViewContainerPartnersPage' : ( isMobile ? 'mainOptionsMainColViewContainerPartnersPage' : 'mainOptionsMainColViewContainerPartnersPageMobile') } onClick={() => handleNavBoxClick(item)} key={index}>
                                                <div className='txtInfoNavBoxRowOneViewContainerPartnersPage' style={ isTablet ? { marginBottom: '-12px' } : ( isMobile ? { marginBottom: '-12px' } : { marginBottom: '-16px' }) }>
                                                    <div className='txtInfoNavBoxRowLeftViewContainerPartnersPage'>
                                                        <img src={renderIconByItem(item)?.img} alt="imagem" className="iconInfoNavBoxRegBlackPartnersPage" />
                                                        <div className='txtInfoNavBoxRegBlackPartnersPage'>{item.categoria}</div>
                                                    </div>
                                                    { item.novidade == 'S' &&
                                                    <div className='txtInfoNavBoxBoldSmallTitleViewContainerPartnersPage'>
                                                        <div className='txtInfoNavBoxBoldSmallTitlePartnersPage'>NOVIDADE</div>
                                                    </div>
                                                    }
                                                </div>
                                                <div className='txtInfoNavBoxRowLeftViewContainerPartnersPage'>
                                                    {item?.nomeparceiro.length > 31 ?
                                                        <>
                                                            <div className='txtInfoNavBoxBoldTitlePartnersPage'>{handkeChangeMaxLength(item.nomeparceiro, 31)}</div>

                                                            <div className='alertHoverInfoMainViewPartnersPage'>
                                                                <div className='mainViewAlerSmModalPartnersPage'>
                                                                    <div className='txtAlerSmModalPartnersPage'>{item.nomeparceiro}</div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    : 
                                                        <div className='txtInfoNavBoxBoldTitlePartnersPage'>{item.nomeparceiro}</div> 
                                                    }
                                                </div>
                                                <div className='imgInfoNavBoxViewPartnersPage'>
                                                    <img 
                                                        src={item.urlImagem} 
                                                        alt="imagem" 
                                                        className={ isTablet ? 'imgInfoNavBoxPartnersPage' : ( isMobile ? 'imgInfoNavBoxPartnersPage' : 'imgInfoNavBoxPartnersPageMobile')} 
                                                    />
                                                </div>
                                                <div className='spacerInfoNavBoxPartnersPage'/>
                                                <div className='txtInfoNavBoxRowLeftViewContainerPartnersPage'>
                                                    <div className='txtInfoNavBoxBlueViewPartnersPage'>
                                                        <span className='txtInfoNavBoxBoldBluePartnersPage'>{item.infoCard.split('cashback')[0]}cashback</span>
                                                        <span className='txtInfoNavBoxRegBluePartnersPage'>{item.infoCard.split('cashback').slice(1).join('cashback')}</span>
                                                    </div>
                                                </div>
                                                <div className='txtInfoNavBoxRowViewContainerPartnersPage'>
                                                    <div className='txtInfoNavBoxRowLeftViewContainerPartnersPage'>
                                                        <div className='iconInfoNavBoxViewPartnersPage'><RiMapPinLine className='iconInfoNavBoxRegBlackPartnersPage'/></div>
                                                        { (myLocation !== '' && item?.proximidade?.length > 0 ) &&
                                                        <div className='txtInfoNavBoxRegBlackPartnersPage'>{item.proximidade} Km</div>
                                                        }
                                                    </div>
                                                    <div className='txtInfoNavBoxRowRightViewContainerPartnersPage'>
                                                        { myLocation !== '' &&
                                                            <div className='txtInfoNavBoxSemiBoldBlackPartnersPage'>{item.nLocalidadesParceiros} {item.nLocalidadesParceiros === '1' ? 'Localização' : 'Localizações'}</div>
                                                        }
                                                        <div className='iconInfoNavBoxViewPartnersPage'>
                                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxPartnersPage' />
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div> 
                                ) : (
                                    <div className={ isTablet ? 'noDataViewContainerPartnersPage' : ( isMobile ? 'noDataViewContainerPartnersPageTablet' : 'noDataViewContainerPartnersPageMobile' )}>
                                        <div className='txtNoMovementContentColumnViewContainerPartnersPage'>
                                            <div className="noMovementDataIconViewPartnersPage">
                                                <img src={ImgNoMovementsDataSvg} alt="icon" className="noMovementDataIconPartnersPage" />
                                            </div>
                                            <div className='txtNoMovementColumnViewContainerPartnersPage'>
                                                <div className='txtFirstOptionsTitlePartnersPage'>
                                                    <span className='txtFirstOptionsTitlePartnersPage'>Sem resultados</span>
                                                    {seacrhForNamePartner.length > 0 &&
                                                        <span className='txtFirstOptionsTitlePartnersPage'> para {seacrhForNamePartner}</span>
                                                    }
                                                    <span className='txtFirstOptionsTitlePartnersPage'>.</span>
                                                </div>
                                                <div className='txtNoMovementSmallPartnersPage'>Use os filtros para refinar a sua pesquisa ou use outros termos de pesquisa</div>
                                            </div>
                                        </div>
                                        <div className='txtNoMovementBtnColumnViewContainerPartnersPage'>
                                            <CustomButton 
                                                text={'Remover filtros'} 
                                                textColor={'#00214D'}
                                                onPress={handleClearFilter}
                                                enabled={handleEnabledBtnFilter()}
                                                color={'#15D4B6'}
                                                hasArrow
                                                iconType={'close'}
                                                iconColor={'#00214D'}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                            }
                            {/* End fifth div componet with info blocks list */}
                        </div>                    
                    </div>
                </div>   
                <div className='mainPaginationViewContainerPartnersPage'>
                    { (listaParceirosResp?.length > 0 && numeroDePaginas > 1) && (
                        <ListPagination numPage={numeroDePaginas} pageNumber={pageNumber} setPageSelected={setPageNumber}/>
                    )}
                </div>
            </div>
        </div>
        </>
        }
        <Footer/> 
        </>
    )
}

export default PartnersPage;